import type { NavigateFunction } from 'react-router-dom';

let registered = false;

export async function registerDeepLinkHandler(navigate: NavigateFunction): Promise<void> {
  if (registered) return;
  registered = true;

  try {
    const cap = await import('@capacitor/core');
    if (!cap.Capacitor.isNativePlatform()) return;

    const { App } = await import('@capacitor/app');

    App.addListener('appUrlOpen', (event) => {
      try {
        const url = new URL(event.url);
        const targetPath = `${url.pathname}${url.search}${url.hash}`;
        if (targetPath && targetPath !== '/') {
          navigate(targetPath, { replace: true });
        }
      } catch {
        // Malformed deep link — ignore
      }
    });
  } catch {
    // @capacitor/app not installed or not running on a native platform — silent no-op.
  }
}
